import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUserData } from 'hooks/useUserData';
import Text from 'components/text';
import EmbeddedApp from 'components/embedded-app';

// Built touring app served same-origin by default; `.env.local` can point at the Vite dev server.
const TOUR_BUDGET_URL = process.env.REACT_APP_TOUR_BUDGET_URL || '/tour-budget-app/index.html';

const TourBudgetSection: React.FC = () => {
  const { t } = useTranslation();
  const { permissionsData } = useUserData();

  if (!permissionsData?.education) {
    return (
      <Box padding={3}>
        <Text>
          {t(
            'Sorry, the page you are looking for does not exist, please contact with us if you are facing an issues.'
          )}
        </Text>
      </Box>
    );
  }

  // A `#t=<payload>` share link reaches the app through the hash; the app clears it once imported.
  return (
    <EmbeddedApp
      title={t('Tour budget')}
      url={TOUR_BUDGET_URL}
      allow="clipboard-write; fullscreen"
    />
  );
};

export default TourBudgetSection;
